import { AssetQuoteQuery } from '@interfaces/graphql-typings';

enum DataTypes {
  idea = 'IDEA',
  ideaUpdate = 'IDEA_UPDATE'
}
type AssetData = NonNullable<AssetQuoteQuery['asset']>;
type ParsedIdeaData = NonNullable<
  NonNullable<NonNullable<AssetData['ideasInTimeframe']>['edges']>[number]
>['node'];
type ParsedUpdateData = NonNullable<
  NonNullable<NonNullable<AssetData['ideaUpdatesInTimeframe']>['edges']>[number]
>['node'];
type ToolTipContent = {
  date?: string | null;
  data: ParsedIdeaData | ParsedUpdateData;
  type: DataTypes;
};

const parseIdeaData = (asset: AssetData): ParsedIdeaData[] => {
  return asset.ideasInTimeframe && asset.ideasInTimeframe.edges
    ? asset.ideasInTimeframe.edges.map(edge => (edge?.node ? edge.node : null)).filter(i => i)
    : [];
};

const parseIdeaUpdates = (asset: AssetData): ParsedUpdateData[] => {
  return asset.ideaUpdatesInTimeframe && asset.ideaUpdatesInTimeframe.edges
    ? asset.ideaUpdatesInTimeframe.edges.map(edge => (edge?.node ? edge.node : null)).filter(i => i)
    : [];
};

const parseData = (
  asset: AssetData
): { ideas: ParsedIdeaData[]; ideaUpdates: ParsedUpdateData[] } => {
  return {
    ideas: parseIdeaData(asset),
    ideaUpdates: parseIdeaUpdates(asset)
  };
};

const generateTooltipData = (
  type: DataTypes,
  data: ParsedIdeaData[] | ParsedUpdateData[]
): ToolTipContent[] => {
  switch (type) {
    case DataTypes.idea:
      return data.map(idea => ({
        date: idea?.createdAt,
        data: idea,
        type: type
      }));
    case DataTypes.ideaUpdate:
      return data.map(ideaUpdate => ({
        date: ideaUpdate?.createdAt,
        data: ideaUpdate,
        type: type
      }));
    default:
      return [];
  }
};

export const getTooltipData = (asset: AssetQuoteQuery['asset'] | undefined): ToolTipContent[] => {
  if (!asset) return [];

  const { ideas, ideaUpdates } = parseData(asset);

  const ideasTooltipData = generateTooltipData(DataTypes.idea, ideas);
  const ideaUpdatesTooltipData = generateTooltipData(DataTypes.ideaUpdate, ideaUpdates);

  return [...ideasTooltipData, ...ideaUpdatesTooltipData];
};
